import * as $ from 'jquery';
import AppSingleton from '../../services/appSingleton';
import App from '../app';
import FlashInfo from './../flashinfo/flashinfo';
export default class Header {

    private flashInfos: FlashInfo;
    private header: any;
    private headerMain: any;
    private app: App;


    constructor() {
        this.app = AppSingleton.getInstance();
        this.header = $("#header");
        this.headerMain = this.header.find('.header-main');

        $(document).ready(() => {
            this.setMarginHeader();
        });

        this.flashInfos = new FlashInfo($('#flashinfos-container'), () => this.setMarginHeader());

        this.initMenus();
    }

    getHeader() {
        return this.header;
    }

    initMenus() {
        let app = AppSingleton.getInstance();
        let mouseIsInMenu = false;
        let nav = $('#nav');
        let menusWrapper = nav.find('.menus-wrapper');
        let overlay = $('<div>').appendTo('body').css({
            background: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 0,
            transition: '0.3s opacity ease',
            height: 0,
            zIndex: 99,
        });

        let blog = nav.find('.nav-primary > .level0.blog');
        let formawell = nav.find('.nav-primary > .level0.formawell');
        const childlessTabs = [blog, formawell];

        nav.find('.nav-primary > .level0 a.has-children').on('touchend click', function (e) {
            if (app.isMobile()) {
                const input = $('#' + $(this).data('for'));
                input.trigger('click');

                e.preventDefault();
            }
        });

        nav.find('.nav-primary > .level0').on('mouseenter', function () {
            if (!app.isMobile()) {
                menusWrapper.find('.submenu').hide();
                menusWrapper.find('.submenu.' + $(this).data('position')).show();
            }
        });

        nav.find('.nav-primary > .level0').on('mouseenter', function () {
            if (!app.isMobile()) {
                mouseIsInMenu = true;
                setTimeout(function () {
                    if (!app.isMobile()) {
                        if (mouseIsInMenu) {
                            menusWrapper.addClass('opened');
                            overlay.css({opacity: 1, height: 'auto'});
                        }
                    }
                }, 150);
            }
        });

        childlessTabs.forEach(element => {
            element.on('mouseenter', () => {
                if (!app.isMobile()) {
                    mouseIsInMenu = false;
                    menusWrapper.removeClass('opened');
                    overlay.css({opacity: 0, height: 0});
                }
            });
        });

        nav.on('mouseleave', () => {
            if (!app.isMobile()) {
                mouseIsInMenu = false;
                menusWrapper.removeClass('opened');
                overlay.css({opacity: 0, height: 0});
            }
        });

        nav.find('.submenu').on('mouseenter', function () {
            if (!app.isMobile()) {
                nav.find('.level0.' + $(this).data('submenuposition')).addClass('over-submenu');
            }
        });

        nav.find('.submenu').on('mouseleave', function () {
            if (!app.isMobile()) {
                nav.find('.level0.' + $(this).data('submenuposition')).removeClass('over-submenu');
            }
        });

        $(window).resize(() => {
            this.setMarginHeader();
        });
    }


    /**
     * Creat margin header for flash
     */
    setMarginHeader() {
        if (this.app.isMobile()) {
            let flashInfoHeight = $('#flashinfos-container').outerHeight();
            flashInfoHeight = typeof flashInfoHeight !== "undefined" ? flashInfoHeight : 0;
            this.headerMain.css("top", flashInfoHeight);
            $('body').css("padding-top", flashInfoHeight + this.headerMain.outerHeight());
            $('.login-wrapper').css("top", flashInfoHeight + this.headerMain.outerHeight());
            $('.minicart-wrapper').css("top", flashInfoHeight + this.headerMain.outerHeight());
        } else {
            this.headerMain.css("top", 0);
            $('body').css("padding-top", '');
            $('.login-wrapper').css("top", '');
            $('.minicart-wrapper').css("top", '');
        }
    }
}